export const FETCH_STUFF = 'FETCH_STUFF';
export const RECEIVE_STUFF = 'RECEIVE_STUFF';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_FAILURE = 'SHOW_FAILURE';
export const TOKEN_SUCCESS = 'TOKEN_SUCCESS';
export const TOKEN_FAILURE = 'TOKEN_FAILURE';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const HIDE_ALERTS = 'HIDE_ALERTS';
export const GET_TOKEN_FAILURE = 'GET_TOKEN_FAILURE';
export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS';
export const GET_NODE_DATA_SUCCESS = 'GET_NODE_DATA_SUCCESS';
export const GET_NODE_DATA_FAILURE = 'GET_NODE_DATA_FAILURE';
export const CURRENT_NODE_INFO = 'CURRENT_NODE_INFO';
export const EMAIL_RESET_SENT = 'EMAIL_RESET_SENT';
export const EMAIL_RESET_FAIL = 'EMAIL_RESET_FAIL';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js